import React, { Component } from 'react';
import { PricedProduct } from '~/Product';
import Button from '~/UI/Button';
import buttonIconStyles from '~/UI/Button/icon.less';
import Icon from '~/UI/Icon/Icon';

type Product = PricedProduct<any>;
interface Props {
	pricedProduct: Product | null;
	onRemoveProduct(product: Product): void;
}

export default class ProductAddAccessory extends Component<Props> {
	static defaultProps = {
		pricedProduct: null,
	};

	render() {
		const { pricedProduct, onRemoveProduct } = this.props;
		const clicked = () => {
			if (pricedProduct !== null) {
				onRemoveProduct(pricedProduct);
			}
		};

		return (
			<Button styles={buttonIconStyles} tabIndex={-1} onClick={clicked}>
				<Icon name='remove'>remove</Icon>
			</Button>
		);
	}
}
